import styled from 'styled-components';

interface TextSpanProps {
  $isBold?: boolean;
  $isItalic?: boolean;
  $isUnderline?: boolean;
}

export const TextSpan = styled.span<TextSpanProps>`
  font-weight: ${(props) => (props.$isBold ? 'bold' : 'normal')};
  font-style: ${(props) => (props.$isItalic ? 'italic' : 'normal')};
  text-decoration: ${(props) => (props.$isUnderline ? 'underline' : 'none')};
`;
